/* 用户相关接口 */
import http from '@/utils/http-v4'
import config from '@/config/config'

const api = {
  getToken: `${config.apiv4Root}/inner4/user/token:v1token`,
  getUserInfo: `${config.apiv4Root}/inner4/ilisten/user/vip:get`
}

export async function getV4Token(v1token) {
  let res = await http.post(api.getToken, { v1token })
  return {
    token: res.data.token,
    expireTime: res.data.expire_time
  }
}

export function getUserInfo () {
  return http.get(api.getUserInfo)
}
